/**
 * Created by yqr on 2019/2/20.
 */
import Vue from "vue";
import Router from "vue-router";
import TopNav from "@/components/nav/topNav.vue";
import LeftNav from "@/components/nav/leftNav.vue";
import Home from "@/views/home.vue";
import NotFound from "@/components/404.vue";
import Dashboard from "@/views/platform/dashboard.vue";
import Main from "@/views/main.vue";
import VueCookies from "vue-cookies";
//平台开发菜单
//连接设备
import protocolLibraryManagement from "@/views/platform/protocolLibraryManagement.vue"; //网关协议库
import moduleManagement from "@/views/platform/moduleManagement.vue"; //网关管理
import gatewayManagement from "@/views/platform/gatewayManagement.vue"; //网关管理
import protocolAdd from "@/views/platform/protocolAdd.vue"; //创建网关协议
import moduleAdd from "@/views/platform/moduleAdd.vue"; //创建网关
import gatewayAdd from "@/views/platform/gatewayAdd.vue"; //创建网关
import moduleDetail from "@/views/platform/moduleDetail.vue"; //网关详情
import moduleProtocolDetails from "@/views/platform/moduleProtocolDetails.vue"; //网关协议详情
import gatewayDetails from "@/views/platform/gatewayDetails.vue"; //网关详情
import routeEmptyeba from "@/views/platform/routeEmptyeba.vue"; //空页面
import moduleLog from "@/views/platform/moduleLog.vue"; //网关日志
//设备管理

import equipmentProtocolLibrary from "@/views/platform/equipmentProtocolLibrary.vue"; //设备协议库
import equipmentManagement from "@/views/platform/equipmentManagement.vue"; //设备管理
import equipmentGrouping from "@/views/platform/equipmentGrouping.vue"; //设备分类
import equipmentAdd from "@/views/platform/equipmentAdd.vue"; //创建设备
import equipmentDetail from "@/views/platform/equipmentDetail.vue"; //设备详情
import equipmentViewData from "@/views/platform/equipmentViewData.vue"; //设备采集点数据
import equimentProtocolAdd from "@/views/platform/equimentProtocolAdd.vue"; //创建设备协议
import uplinkPackage from "@/views/platform/uplinkPackage.vue"; //配置上行包体
import downlinkPackage from "@/views/platform/downlinkPackage.vue"; //配置下行包体
import equimentProtocolDetails from "@/views/platform/equimentProtocolDetails.vue"; //设备协议详情
import deviceTransfer from "@/views/platform/deviceTransfer.vue"; //设备转移
//规则引擎
import sceneLinkage from "@/views/platform/sceneLinkage.vue"; //场景联动
import ruleEngineList from "@/views/platform/ruleEngineList.vue"; //策略详情（创建规则）
import ruleCondition from "@/views/platform/ruleCondition.vue"; //创建规则-设置条件
import alarmCenter from "@/views/platform/alarmCenter.vue"; //告警中心
//调试中心
import equimentDebug from "@/views/platform/equimentDebug.vue"; //设备调试
import scriptDebug from "@/views/platform/scriptDebug.vue"; //脚本调试
//系统管理
import dictionaryManagement from "@/views/platform/dict.vue"; //字典管理
import userManagement from "@/views/platform/userManagement.vue"; //用户管理
import roleManagement from "@/views/platform/roleManagement.vue"; //角色管理
import menuManagement from "@/views/platform/menuManagement.vue"; //角色管理
import thirdPartyAuthorization from "@/views/platform/thirdPartyAuthorization.vue"; //第三方登录授权
import enterpriseApplication from "@/views/platform/enterpriseApplication.vue"; //企业申请
import userPersonal from "@/views/platform/userPersonal.vue"; //用户详情，个人信息
import loginLog from "@/views/platform/loginLog.vue"; // 登录日志
import operLog from "@/views/platform/operLog.vue"; // 操作日志
//萤石云账号管理
import ysAccountList from "@/views/platform/ysAccountList.vue"; //萤石云账号列表
import ysAccountAdd from "@/views/platform/ysAccountAdd.vue"; //创建萤石云账号
import ysAccountAssociatedDevice from "@/views/platform/ysAccountAssociatedDevice.vue"; //萤石云账号权限分配
//推送服务
import httpPushList from "@/views/platform/httpPushList.vue"; //http推送服务列表
import rabbitMQPushList from "@/views/platform/rabbitMQPushList.vue"; //rabbitMQ推送服务列表
import kafkaPushList from "@/views/platform/kafkaPushList.vue"; //kafka推送服务列表
import httpPushAdd from "@/views/platform/httpPushAdd.vue"; //新增http推送服务
import rabbitMQPushAdd from "@/views/platform/rabbitMQPushAdd.vue"; //新增rabbitMQ推送服务
import kafkaPushAdd from "@/views/platform/kafkaPushAdd.vue"; //新增kafka推送服务

//产品服务
import productManagement from "@/views/platform/productManagement.vue"; //产品列表
import productAdd from "@/views/platform/productAdd.vue"; //产品编辑
import productDetail from "@/views/platform/productDetail.vue"; //产品详情

// 系统运行日志
import DataPush from "@/views/platform/DataPush.vue"; // 数据推送日志
import SceneLinkageLog from "@/views/platform/SceneLinkageLog.vue"; // 场景联动控制日志

// 懒加载方式，当路由被访问的时候才加载对应组件
const Redirection = resolve => require(["@/views/redirection"], resolve);
const SsoLogin = resolve => require(["@/views/ssoLogin"], resolve);
const PasswordSsoLogin = resolve =>
    require(["@/views/passwordSsoLogin"], resolve);

const noLogins = ["/login", "/redirection", "/ssoLogin", "/passwordSsoLogin"];

Vue.use(Router);

let router = new Router({
    routes: [{
            path: "/ssoLogin",
            type: "login",
            component: SsoLogin
        },
        {
            path: "/passwordSsoLogin",
            type: "login",
            component: PasswordSsoLogin
        },
        {
            path: "*",
            component: NotFound
        },
        {
            path: "/noRequired",
            name: "创建and详情",
            component: Home,
            children: [{
                    path: "/routeEmptyeba",
                    name: "routeEmptyeba",
                    components: {
                        default: routeEmptyeba,
                        top: TopNav
                    },
                    leaf: true,
                    meta: {
                        menuShow: false
                    }
                },
                {
                    path: "/device/moduleDetail",
                    name: "网关详情",
                    components: {
                        default: moduleDetail,
                        top: TopNav
                    },
                    leaf: true,
                    meta: {
                        menuShow: false
                    }
                },
                {
                    path: "/ysManager/ysAccountAssociatedDevice",
                    name: "萤石账号关联设备",
                    components: {
                        default: ysAccountAssociatedDevice,
                        top: TopNav
                    },
                    leaf: true,
                    meta: {
                        menuShow: false
                    }
                },
                {
                    path: "/ysManager/ysAccountAdd",
                    name: "创建萤石账号",
                    components: {
                        default: ysAccountAdd,
                        top: TopNav
                    },
                    leaf: true,
                    meta: {
                        menuShow: false
                    }
                },
                {
                    path: "/pushService/httpPushAdd",
                    name: "创建http推送服务",
                    components: {
                        default: httpPushAdd,
                        top: TopNav
                    },
                    leaf: true,
                    meta: {
                        menuShow: false
                    }
                },
                {
                    path: "/pushService/rabbitMQPushAdd",
                    name: "创建rabbitMQ推送服务",
                    components: {
                        default: rabbitMQPushAdd,
                        top: TopNav
                    },
                    leaf: true,
                    meta: {
                        menuShow: false
                    }
                },
                {
                    path: "/pushService/kafkaPushAdd",
                    name: "创建kafka推送服务",
                    components: {
                        default: kafkaPushAdd,
                        top: TopNav
                    },
                    leaf: true,
                    meta: {
                        menuShow: false
                    }
                },
                {
                    path: "/device/moduleProtocolDetails",
                    name: "网关协议详情",
                    components: {
                        default: moduleProtocolDetails,
                        top: TopNav
                    },
                    leaf: true,
                    meta: {
                        menuShow: false
                    }
                },
                {
                    path: "/device/gatewayDetails",
                    name: "网关详情",
                    components: {
                        default: gatewayDetails,
                        top: TopNav
                    },
                    leaf: true,
                    meta: {
                        menuShow: false
                    }
                },

                {
                    path: "/device/protocolAdd",
                    name: "创建网关协议",
                    components: {
                        default: protocolAdd,
                        top: TopNav
                    },
                    leaf: true,
                    meta: {
                        menuShow: false
                    }
                },
                {
                    path: "/device/moduleAdd",
                    name: "创建网关",
                    components: {
                        default: moduleAdd,
                        top: TopNav
                    },
                    leaf: true,
                    meta: {
                        menuShow: false
                    }
                },
                {
                    path: "/device/gatewayAdd",
                    name: "创建网关",
                    components: {
                        default: gatewayAdd,
                        top: TopNav
                    },
                    leaf: true,
                    meta: {
                        menuShow: false
                    }
                },
                {
                    path: "/equipment/equipmentAdd",
                    name: "创建设备",
                    components: {
                        default: equipmentAdd,
                        top: TopNav
                    },
                    leaf: true,
                    meta: {
                        menuShow: false
                    }
                },

                {
                    path: "/equipment/equipmentDetail",
                    name: "设备详情",
                    components: {
                        default: equipmentDetail,
                        top: TopNav
                    },
                    leaf: true,
                    meta: {
                        menuShow: false
                    }
                },
                {
                    path: "/equipment/equipmentViewData",
                    name: "设备采集点数据",
                    components: {
                        default: equipmentViewData,
                        top: TopNav
                    },
                    leaf: true,
                    meta: {
                        menuShow: false
                    }
                },

                {
                    path: "/equipment/equimentProtocolAdd",
                    name: "创建设备协议",
                    components: {
                        default: equimentProtocolAdd,
                        top: TopNav
                    },
                    leaf: true,
                    meta: {
                        menuShow: false
                    }
                },
                {
                    path: "/equipment/equimentProtocolDetails",
                    name: "设备协议详情",
                    components: {
                        default: equimentProtocolDetails,
                        top: TopNav
                    },
                    leaf: true,
                    meta: {
                        menuShow: false
                    }
                },
                {
                    path: "/equipment/uplinkPackage",
                    name: "配置上行包体",
                    components: {
                        default: uplinkPackage,
                        top: TopNav
                    },
                    leaf: true,
                    meta: {
                        menuShow: false
                    }
                },
                {
                    path: "/equipment/downlinkPackage",
                    name: "配置下行包体",
                    components: {
                        default: downlinkPackage,
                        top: TopNav
                    },
                    leaf: true,
                    meta: {
                        menuShow: false
                    }
                },
                {
                    path: "/rules/ruleEngineList",
                    name: "策略详情",
                    components: {
                        default: ruleEngineList,
                        top: TopNav
                    },
                    leaf: true,
                    meta: {
                        menuShow: false
                    }
                },
                {
                    path: "/rules/ruleCondition",
                    name: "创建规则-设置条件",
                    components: {
                        default: ruleCondition,
                        top: TopNav
                    },
                    leaf: true,
                    meta: {
                        menuShow: false
                    }
                },
                {
                    path: "/user/userPersonal",
                    name: "个人中心",
                    components: {
                        default: userPersonal,
                        top: TopNav
                    },
                    leaf: true,
                    meta: {
                        menuShow: false
                    }
                },
                {
                    path: "/product/productAdd",
                    name: "产品编辑",
                    components: {
                        default: productAdd,
                        top: TopNav
                    },
                    leaf: true,
                    meta: {
                        menuShow: false
                    }
                },
                {
                    path: "/product/productDetail",
                    name: "产品详情",
                    components: {
                        default: productDetail,
                        top: TopNav
                    },
                    leaf: true,
                    meta: {
                        menuShow: false
                    }
                },
            ]
        },
        //iot平台
        {
            path: "/",
            type: "IotParent",
            name: "IotParent",
            menuCode: "IotParent",
            redirect: "/dashboard",
            // redirect: '/device/protocolLibraryManagement',
            component: Home,
            children: [{
                    path: "/dashboard",
                    name: "总览",
                    menuCode: "dashboard",
                    components: {
                        default: Dashboard,
                        top: TopNav,
                        aside: LeftNav
                    },
                    leaf: true, // 只有一个节点
                    meta: {
                        menuShow: true
                    }
                },
                {
                    path: "/device",
                    name: "连接设备",
                    menuCode: "device",
                    components: {
                        default: Main,
                        top: TopNav,
                        aside: LeftNav
                    },
                    children: [{
                            path: "/device/dashboard",
                            name: "协议首页",
                            menuCode: "dashboard",
                            components: {
                                default: Dashboard,
                                top: TopNav,
                                aside: LeftNav
                            },
                            leaf: true, // 只有一个节点
                            meta: {
                                menuShow: false
                            }
                        },
                        {
                            path: "/device/protocolLibraryManagement",
                            component: protocolLibraryManagement,
                            menuCode: "protocolLibraryManagement",
                            name: "网关协议库",
                            meta: {
                                menuShow: false
                            }
                        },
                        {
                            path: "/device/moduleManagement",
                            component: moduleManagement,
                            menuCode: "moduleManagement",
                            name: "网关管理",
                            meta: {
                                menuShow: false
                            }
                        },
                        {
                            path: "/device/moduleLog",
                            component: moduleLog,
                            menuCode: "moduleLog",
                            name: "网关日志",
                            meta: {
                                menuShow: false
                            }
                        },
                        {
                            path: "/device/gatewayManagement",
                            component: gatewayManagement,
                            menuCode: "gatewayManagement",
                            name: "网关管理",
                            meta: {
                                menuShow: false
                            }
                        }
                    ],
                    meta: {
                        menuShow: false
                    }
                },
                {
                    path: "/equipment",
                    name: "设备管理",
                    menuCode: "equipment",
                    components: {
                        default: Main,
                        top: TopNav,
                        aside: LeftNav
                    },
                    children: [{
                            path: "/equipment/equipmentProtocolLibrary",
                            component: equipmentProtocolLibrary,
                            menuCode: "equipmentProtocolLibrary",
                            name: "设备协议库",
                            meta: {
                                menuShow: false
                            }
                        },
                        {
                            path: "/equipment/equipmentManagement",
                            component: equipmentManagement,
                            menuCode: "equipmentManagement",
                            name: "设备管理 ",
                            meta: {
                                menuShow: false
                            }
                        },
                        {
                            path: "/equipment/deviceTransfer",
                            component: deviceTransfer,
                            menuCode: "deviceTransfer",
                            name: "设备转移 ",
                            meta: {
                                menuShow: false
                            }
                        }
                    ],
                    meta: {
                        menuShow: false
                    }
                },
                {
                    path: "/debug",
                    name: "调试中心",
                    menuCode: "debug",
                    components: {
                        default: Main,
                        top: TopNav,
                        aside: LeftNav
                    },
                    children: [{
                            path: "/debug/equimentDebug",
                            component: equimentDebug,
                            menuCode: "equimentDebug",
                            name: "设备调试",
                            meta: {
                                menuShow: false
                            }
                        },
                        {
                            path: "/debug/scriptDebug",
                            component: scriptDebug,
                            menuCode: "scriptDebug",
                            name: "脚本调试",
                            meta: {
                                menuShow: false
                            }
                        }
                    ],
                    meta: {
                        menuShow: false
                    }
                },
                {
                    path: "/rules",
                    name: "规则引擎",
                    menuCode: "rules",
                    components: {
                        default: Main,
                        top: TopNav,
                        aside: LeftNav
                    },
                    children:[{
                            path: "/rules/sceneLinkage",
                            component: sceneLinkage,
                            menuCode: "sceneLinkage",
                            name: "场景联动",
                            meta: {
                                menuShow: false
                            }
                        },
                        {
                            path: "/rules/alarmCenter",
                            component: alarmCenter,
                            menuCode: "alarmCenter",
                            name: "告警中心",
                            meta: {
                                menuShow: false
                            }
                        }
                    ],
                    meta: {
                        menuShow: false
                    }
                },

                {
                    path: "/system",
                    name: "系统管理",
                    menuCode: "system",
                    components: {
                        default: Main,
                        top: TopNav,
                        aside: LeftNav
                    },
                    children: [{
                            path: "/system/dictionaryManagement",
                            component: dictionaryManagement,
                            menuCode: "dictionaryManagement",
                            name: "字典管理",
                            meta: {
                                menuShow: false
                            }
                        },
                        {
                            path: "/system/userManagement",
                            component: userManagement,
                            name: "用户管理",
                            menuCode: "userManagement",
                            meta: {
                                menuShow: false
                            }
                        },
                        {
                            path: "/system/roleManagement",
                            component: roleManagement,
                            name: "角色管理",
                            menuCode: "roleManagement",
                            meta: {
                                menuShow: false
                            }
                        },
                        {
                            path: "/system/menuManagement",
                            component: menuManagement,
                            name: "菜单管理",
                            menuCode: "sysMenuPermission",
                            meta: {
                                menuShow: false
                            }
                        },
                        {
                            path: "/system/thirdPartyAuthorization",
                            component: thirdPartyAuthorization,
                            name: "第三方授权",
                            menuCode: "thirdPartyAuthorization",
                            meta: {
                                menuShow: false
                            }
                        },
                        {
                            path: "/system/equipmentGrouping",
                            component: equipmentGrouping,
                            menuCode: "equipmentGrouping",
                            name: "分类管理",
                            meta: {
                                menuShow: false
                            }
                        },
                       
                    ],
                    meta: {
                        menuShow: false
                    }
                },
                {
                    path: "/ysManager",
                    name: "萤石云账号管理",
                    menuCode: "ysManager",
                    components: {
                        default: Main,
                        top: TopNav,
                        aside: LeftNav
                    },
                    children: [{
                        path: "/ysManager/ysAccountList",
                        component: ysAccountList,
                        menuCode: "ysAccountList",
                        name: "萤石云账号列表",
                        meta: {
                            menuShow: false
                        }
                    }],
                    meta: {
                        menuShow: false
                    }
                },
                {
                    path: "/pushService",
                    name: "推送服务",
                    menuCode: "pushService",
                    components: {
                        default: Main,
                        top: TopNav,
                        aside: LeftNav
                    },
                    children: [{
                            path: "/pushService/httpPushList",
                            component: httpPushList,
                            menuCode: "httpPushList",
                            name: "http推送",
                            meta: {
                                menuShow: false
                            }
                        },
                        {
                            path: "/pushService/rabbitMQPushList",
                            component: rabbitMQPushList,
                            menuCode: "rabbitMQPushList",
                            name: "RabbitMQ推送",
                            meta: {
                                menuShow: false
                            }
                        },
                        {
                          path: "/pushService/kafkaPushList",
                          component: kafkaPushList,
                          menuCode: "kafkaPushList",
                          name: "kafka推送",
                          meta: {
                            menuShow: false
                          }
                        },
                    ],
                    meta: {
                        menuShow: false
                    }
                },
                {
                    path: "/enterpriseApplication",
                    name: "企业申请",
                    components: {
                        default: enterpriseApplication,
                        top: TopNav,
                        aside: LeftNav
                    },
                    leaf: true, // 只有一个节点
                    meta: {
                        menuShow: false
                    }
                },
                {
                    path: "/product",
                    name: "产品管理",
                    menuCode: "product",
                    meta: {
                        menuShow: false
                    },
                    components: {
                        default: Main,
                        top: TopNav,
                        aside: LeftNav
                    },
                    children: [{
                        path: "/product/productManagement",
                        name: "产品列表",
                        menuCode: "productManagement",
                        components: {
                            default: productManagement,
                            top: TopNav,
                            aside: LeftNav
                        },
                        meta: {
                            menuShow: false
                        }
                    }]
                },
                {
                    path:"/SystemRunLog",
                    name:"系统运行日志",
                    menuCode:"SystemRunLog",
                    meta: {
                        menuShow: false
                    },
                    components: {
                        default: Main,
                        top: TopNav,
                        aside: LeftNav
                    },
                    children:[
                        {
                            path:"/SystemRunLog/DataPush",
                            component:DataPush,
                            menuCode:"DataPush",
                            name:"数据推送日志",
                            meta:{
                                menuShow:false
                            }
                        },
                        {
                            path:"/SystemRunLog/SceneLinkageLog",
                            component:SceneLinkageLog,
                            menuCode:"SceneLinkageLog",
                            name:"场景联动控制日志",
                            meta:{
                                menuShow:false
                            }
                        },
                         {
                           path: "/SystemRunLog/loginLog",
                           component: loginLog,
                           menuCode: "loginLog",
                           name: "登录日志",
                           meta: {
                             menuShow: false
                           }
                         }, {
                           path: "/SystemRunLog/operLog",
                           component: operLog,
                           menuCode: "operLog",
                           name: "操作日志",
                           meta: {
                             menuShow: false
                           }
                         },
                    ]
                }
            ]
        }
    ]
});
var routeList = []; //面包屑容器
var routeObj = {};
router.beforeEach((to, from, next) => {
    if (to.path == "/redirection") {
        window.sessionStorage.setItem(
            "routeList",
            JSON.stringify([{
                name: to.name,
                query: to.query
            }])
        );
    }
    if (to.path.startsWith("/redirection")) {
        VueCookies.remove("access_token");
        next();
    } else {
        let access_token = VueCookies.get("access_token");
        if (!access_token && noLogins.indexOf(to.path) == -1) {
            next({
                path: "/passwordSsoLogin"
            });
        } else {
            //面包屑记录上一级的页面
            var index = routeList.findIndex(item => item.name == to.name);
            if (index !== -1) {
                //如果存在路由列表，则把之后的路由都删掉
                routeList.splice(index + 1, routeList.length - index - 1);
            } else {
                routeObj = {
                    name: to.name,
                    query: to.query
                };
                //如果跳转到的页面是菜单的首页或通过新手引导点击的跳转，就把之前的面包屑内容清空，再赋值新的内容进去
                if (to.meta.menuShow || to.params.guide) {
                    routeList = [];
                    window.sessionStorage.removeItem("routeList");
                    window.sessionStorage.removeItem("query");
                    routeList.push(routeObj);
                    //当跳转的页面没显示在菜单里的，并且没有上一层的页面，
                    //证明是在某个详情页或者新增页刷新页面。就直接在浏览器拿这些数据赋值给面包屑
                } else if (!to.meta.menuShow && from.name == null) {
                    routeList = JSON.parse(window.sessionStorage.getItem("routeList")) ?
                        JSON.parse(window.sessionStorage.getItem("routeList")) :
                        [];
                } else {
                    routeList.push(routeObj);
                }
            }
            // 网关管理
            if (
                ["/device/moduleManagement", "/device/moduleDetail"].indexOf(
                    to.path.trim()
                ) < 0
            ) {
                localStorage.removeItem("moduleParams");
            }
            // 设备管理
            if (
                [
                    "/equipment/equipmentManagement",
                    "/equipment/equipmentDetail",
                    "/equipment/equipmentViewData",
                    "/equipment/equimentProtocolDetails",
                    "/device/moduleDetail"
                ].indexOf(to.path.trim()) < 0
            ) {
                localStorage.removeItem("localParams");
            }
            window.sessionStorage.setItem("routeList", JSON.stringify(routeList));
            to.meta.routeList = routeList;
            next();
        }
    }
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js